<template>
  <div
    v-if="dsComponentDetails.version === VersionOptions.LEGACY"
    class="sb-dropdown-chain-item"
  >
    <SbDropdown
      v-model:value="selectedOperator"
      v-bind="filter.operatorProps"
      :options="operatorsList"
      :results-limit="6"
    >
      <template #selection="scope">
        <sb-selected-option>
          <sb-text :value="scope?.selected?.name" />
        </sb-selected-option>
      </template>
      <sb-options class="operator-options">
        <template #default="scope">
          <sb-option :value="scope?.option">
            <sb-text :value="scope?.option?.name" />
          </sb-option>
        </template>
      </sb-options>
    </SbDropdown>
  </div>
  <SbSelect
    v-else
    v-model="selectedOperator"
    v-bind="filter.operatorProps"
    :options="operatorsList"
    option-label="name"
    option-value="key"
  />
</template>

<script>
import SbSelect from '@src/components/Select/SbSelect.vue';
import SbDropdown from '@src/components/Dropdown/SbDropdown.vue';
import SbSelectedOption from '@src/components/Dropdown/components/SbSelectedOption.vue';
import SbOptions from '@src/components/Dropdown/components/SbOptions.vue';
import SbOption from '@src/components/Dropdown/components/SbOption.vue';
import SbText from '@src/components/Text/SbText.vue';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';

export default {
  name: 'DropdownOperators',
  components: {
    SbSelect,
    SbDropdown,
    SbSelectedOption,
    SbOptions,
    SbOption,
    SbText,
  },
  mixins: [versionedComponentsMixin],
  props: {
    filter: {
      type: Object,
      required: true,
    },
    operator: {
      type: String,
      required: true,
    },
  },
  emits: ['update:operator'],
  computed: {
    operatorsList() {
      return this.filter.operators;
    },
    internalOperator: {
      get() {
        return this.operator ?? this.filter.defaultOperator;
      },
      set(value) {
        this.$emit('update:operator', value);
      },
    },
    selectedOperator: {
      get() {
        const value = this.internalOperator;

        if (this.dsComponentDetails.version === this.VersionOptions.LEGACY) {
          return this.operatorsList.find((x) => x.key === value);
        }

        return this.operatorsList.find((x) => x.key === value)?.key;
      },
      set(value) {
        if (this.dsComponentDetails.version === this.VersionOptions.LEGACY) {
          this.internalOperator = value.key;
        } else {
          this.internalOperator = value;
        }
      },
    },
  },
};
</script>
